export default "__VITE_ASSET__Dlo41c70__";